<template>
  <div
    :class="['reaction-emoji-container', { 'is-reverse': isReverse }]"
    v-if="reaction && reaction.emoji"
  >
    {{ reaction.emoji }}
  </div>
</template>

<script>
export default {
  name: 'AttendanceChatReaction',
  props: {
    reaction: {
      type: Object,
      default: () => ({})
    },
    isReverse: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.reaction-emoji-container {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  position: absolute;
  bottom: -20px;
  left: 5px;
}

.reaction-emoji-container.is-reverse {
  left: auto;
  right: 5px;
}
</style>
